// ANT DESIGN IMPORT
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DislikeOutlined,
  InfoCircleOutlined,
  SafetyOutlined,
  SettingOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Card,
  Col,
  Flex,
  Row,
  Space,
  Statistic,
  Tag,
  Tooltip,
  Typography,
} from "antd";

//CURRENT ACCOUNT ANTD ICONS IMPORT

//PROJECT IMPORT
import Lock01 from "@untitled-ui/icons-react/build/esm/Lock01";
import { BOM } from "../../services/definedMethod";

const { Text, Title, Paragraph } = Typography;

export const AccountFacility = (props) => {
  const {
    status,
    prodDetail,
    isProduct = false,
    name,
    id,
    amount,
    interest,
    interestPerAnnum,
    maturityDate,
    currencyCode,
  } = props;
  console.log(prodDetail);
  const symbol = getCurrencySymbol(currencyCode);

  return (
    <>
      {/* <Card
        bordered={true}
        bodyStyle={{
          paddingTop: 12,
          paddingBottom: 12,
          // paddingLeft: 24,
        }}
        hoverable={true}
        style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
      >
        <Row>
          <Col span={12}>
            <Statistic
              title={"Account Name"}
              value={accountName ? BOM.SubstringFormat(accountName, 20) : "-"}
              valueStyle={{
                fontSize: "16px",
              }}
            />

            <Statistic
              title={"Account Number"}
              value={" "}
              prefix={accountNo ? accountNo : "-"}
              valueStyle={{
                fontSize: "16px",
              }}
            />
          </Col>
          <Col span={12}>
            {status?.text
              ? handleFlgStatus(
                  status?.text,
                  {
                    fontSize: 16,
                  },
                  false,
                  prodDetail
                )
              : "-"}
          </Col>
        </Row>
      </Card> */}
      <Row
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 20,
          marginTop: 24,
          marginBottom: 24,
        }}
      >
        {!isProduct && (
          <Card
            style={{
              backgroundColor: "#FDF4FF",
              borderRadius: "12px",
              height: "164px",
            }}
            bordered={false}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <Space align="center">
                  <Text
                    type="secondary"
                    color="#475467"
                    style={{ fontWeight: 500 }}
                  >
                    Current Balance
                  </Text>
                </Space>
                <Title
                  level={2}
                  style={{ marginBottom: 0, marginTop: 0, fontWeight: 600 }}
                >
                  {symbol}
                  {amount?.toLocaleString() || "0.00"}
                </Title>
              </div>
              <Row style={{ gap: 10, alignItems: "center" }}>
                <Text style={{ color: "#079455" }}>
                  {symbol}
                  {interest?.toLocaleString()}
                </Text>
                <Text
                  style={{
                    color: "#98A2B3",
                    fontSize: "30px",
                    marginBottom: 4,
                  }}
                >
                  •
                </Text>
                <Text>Earned Interest YTD</Text>
              </Row>
            </Space>
          </Card>
        )}

        <Card
          style={{
            flex: 1,
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "12px",
            gridColumn: isProduct ? "2" : "auto",
          }}
        >
          <Flex justify="space-between">
            <Space direction="vertical" size="middle">
              <div>
                <Text type="secondary">
                  {isProduct ? "Product Name" : "Customer Name"}
                </Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {name}
                </Title>
              </div>
              <div>
                <Text type="secondary">
                  {isProduct ? "Product Code" : "Contract ID"}
                </Text>
                <Title level={5} style={{ marginTop: 4, marginBottom: 0 }}>
                  {id}
                </Title>
              </div>
            </Space>

            <Flex gap="large" justify="end">
              <Col>
                {status
                  ? handleFlgStatus(
                      status,
                      {
                        padding: "2px 12px",
                        borderRadius: "16px",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "inline-block",
                        textTransform: "capitalize",
                      },
                      false,
                      prodDetail
                    )
                  : "-"}
              </Col>
            </Flex>
          </Flex>
        </Card>
      </Row>

      {!isProduct && (
        <Row
          style={{
            border: "1px solid #EAECF0",
            borderRadius: "12px",
            padding: "4px 8px",
            marginBottom: 24,
          }}
        >
          <Flex align="center" gap="12px">
            <Lock01
              style={{
                backgroundColor: "#FDF4FF",
                padding: "4px",
                borderRadius: "50%",
                color: "#BA24D5",
                fontSize: "35px",
              }}
            />
            <Flex gap="8px" align="center" wrap="nowrap">
              <Text style={{ color: "#475467" }}>
                This investment is earning{" "}
                <Text strong>{interestPerAnnum}% p.a</Text> and matures on{" "}
                <Text strong>{maturityDate}</Text>.
              </Text>

              <Text
                style={{
                  color: "#98A2B3",
                  fontSize: "30px",
                }}
              >
                •
              </Text>

              <Text style={{ color: "#475467" }}>
                Early termination penalty will be charged{" "}
                <Text strong>according to product terms</Text>.
              </Text>
            </Flex>
          </Flex>
        </Row>
      )}
    </>
  );
};

export const handleFlgStatus = (
  status,
  style = {},
  isListing = false,
  otherParams = {}
) => {
  switch (status.toLowerCase()) {
    case "approved":
      return (
        <Tag
          icon={<SafetyOutlined />}
          color={`${isListing ? "purple" : "#EEF4FF"}`}
          style={{ color: "#3538CD", border: "1px solid #C7D7FE", ...style }}
        >
          {status}
        </Tag>
      );
    case "matured":
      return (
        <Tag
          color={`${isListing ? "purple" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "pending":
      return (
        <Tag
          icon={<SyncOutlined spin />}
          color={`${isListing ? "orange" : "#F4F3FF"}`}
          style={{
            color: "#5925DC",
            border: "1px solid #D9D6FE",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    case "disabled":
      return (
        <Tag
          icon={<DislikeOutlined />}
          color={`${isListing ? "grey" : "#F9FAFB"}`}
          style={{ color: "#344054", border: "1px solid #EAECF0", ...style }}
        >
          {status}
        </Tag>
      );
    case "active" || "success":
      if (otherParams?.inArrears) {
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {"Active in Bad Standing"}
          </Tag>
        );
      } else {
        return (
          <Tag
            // icon={<CheckCircleOutlined />}
            color={"#067647"}
            style={{
              border: "1px solid #ABEFC6",
              backgroundColor: "#ECFDF3",
              color: "#067647",
              padding: "2px 12px",
              borderRadius: "16px",
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              textTransform: "capitalize",
            }}
          >
            {status}
          </Tag>
        );
      }
    case "rejected":
    case "premature closed":
    case "closed":
    case "closed early":
      return (
        <Tag
          icon={<CloseCircleOutlined />}
          color={`${isListing ? "red" : "#FEF3F2"}`}
          style={{
            color: "#B42318",
            border: "1px solid #FECDCA",
            ...style,
          }}
        >
          {status}
        </Tag>
      );
    default:
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          {BOM.SubstringFormat(status, 21)}
        </Tag>
      );
  }
};

export const handleInterBankActionButtons = (prodDetail) => {
  const status = prodDetail?.status?.text;

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
      ];
    case accountStatus.disabled:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Disable",
          key: "1",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    //   case accountStatus.closed:
    //     return [];
    default:
      return [];
  }
};

export const handleInterBankContractActionButtons = (contractDetail) => {
  const status = contractDetail?.status?.text;
  console.log(status.toLowerCase());

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/interbank-contract-action",
          disabled: !BOM.HasPermission("APPROVE_INTERBANKPLACEMENTCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Reject Deal",
          key: "7",
          route: "/interbank-contract-action",
          disabled: !BOM.HasPermission("REJECT_INTERBANKPLACEMENTCONTRACT"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Disburse Deal",
          key: "2",
          route: "/interbank-contract-action",
          disabled: !BOM.HasPermission("DISBURSE_INTERBANKPLACEMENTCONTRACT"),
          icon: <SettingOutlined />,
        },
        // {
        //   label: "Undo Approval",
        //   key: "3",
        //   // route: "/interbank-contract-action",
        //   // disabled: !BOM.HasPermission("UPDATE_INTERBANKPLACEMENTCONTRACT"),
        //   disabled: true,
        //   icon: <SettingOutlined />,
        // },
      ];
    case accountStatus.active:
      return [
        {
          label: "Amend Deal",
          key: "3",
          route: "/interbank-contract-action",
          disabled: !BOM.HasPermission("UPDATE_INTERBANKPLACEMENTCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Deal",
          key: "4",
          route: "/interbank-contract-action",
          disabled: !BOM.HasPermission(
            "PREMATURELYREDEEM_INTERBANKPLACEMENTCONTRACT"
          ),

          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "5",
          disabled: true,

          icon: <SettingOutlined />,
        },

        {
          label: "Redeem Deal",
          key: "6",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleTreasuryBillActionButtons = (prodDetail) => {
  const status = prodDetail?.status?.text;
  console.log(status.toLowerCase());

  switch (status.toLowerCase()) {
    case accountStatus.pending:
      return [
        // {
        //   label: "Modify Application",
        //   key: "1",
        //   //   route: "/savings-account-action",
        //   disabled: !BOM.HasPermission("UPDATE_SAVINGSACCOUNT"),
        //   icon: <EditOutlined />,
        // },
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    case accountStatus.disabled:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Disable",
          key: "1",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    //   case accountStatus.closed:
    //     return [];
    default:
      return [];
  }
};
export const handleTreasuryBillContractActionButtons = (prodDetail) => {
  const status = prodDetail?.status?.text;
  console.log(status?.toLowerCase());

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/treasury-bill-contract-action",
          disabled: !BOM.HasPermission("APPROVE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse Deal",
          key: "2",
          // route: "/treasury-bill-contract-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Amend Deal",
          route: "/treasury-bill-contract-action",
          key: "3",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "4",
          disabled: true,

          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Deal",
          key: "5",
          disabled: !BOM.HasPermission("PREMATURELYREDEEM_BONDCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Close Deal",
          key: "5",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Reject Deal",
          key: "6",
          disabled: !BOM.HasPermission("REJECT_INTERBANKPLACEMENTCONTRACT"),
          icon: <SettingOutlined />,
          route: "/treasury-bill-contract-action",
        },
        {
          label: "Undo Approval",
          key: "7",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/treasury-bill-contract-action",
          disabled: !BOM.HasPermission("APPROVE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse Deal",
          key: "2",
          route: "/treasury-bill-contract-action",
          disabled: !BOM.HasPermission("DISBURSE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Amend Deal",
          key: "3",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "4",
          disabled: true,

          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Deal",
          key: "5",
          disabled: true,

          icon: <SettingOutlined />,
        },
        {
          label: "Close Deal",
          key: "5",
          disabled: true,

          icon: <SettingOutlined />,
        },
        {
          label: "Undo Approval",
          disabled: true,
          // route: "/treasury-bill-contract-action",
          key: "7",
          // disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.disabled:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_TREASURYBILLCONTRACT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("CLOSE_TREASURYBILLCONTRACT"),
          icon: <CheckCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/treasury-bill-contract-action",
          disabled: !BOM.HasPermission("APPROVE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse Deal",
          key: "2",
          route: "/treasury-bill-contract-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Amend Deal",
          key: "3",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "4",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Deal",
          key: "5",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Close Deal",
          key: "6",
          disabled: !BOM.HasPermission("CLOSE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
          route: "/treasury-bill-contract-action",
        },
        {
          label: "Undo Approval",
          key: "7",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.matured:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/treasury-bill-contract-action",
          disabled: !BOM.HasPermission("APPROVE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Disburse Deal",
          key: "2",
          route: "/treasury-bill-contract-action",
          disabled: true,
          icon: <SettingOutlined />,
        },
        {
          label: "Amend Deal",
          key: "3",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "4",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Deal",
          key: "5",
          disabled: !BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT"),
          route: "/treasury-bill-contract-action",
          icon: <SettingOutlined />,
        },
        {
          label: "Close Deal",
          key: "6",
          disabled: !BOM.HasPermission("CLOSE_TREASURYBILLCONTRACT"),
          icon: <SettingOutlined />,
          route: "/treasury-bill-contract-action",
        },
        {
          label: "Undo Approval",
          key: "7",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    //   case accountStatus.closed:
    //     return [];
    default:
      return [];
  }
};

export const handleBondContractActionButtons = (contractDetail, prodDetail) => {
  const status = contractDetail?.status?.text;

  switch (status?.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve Deal",
          key: "1",
          route: "/bond-contract-action",
          disabled: !BOM.HasPermission("APPROVE_BONDCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Reject Deal",
          key: "7",
          route: "/bond-contract-action",
          disabled: !BOM.HasPermission("REJECT_BONDCONTRACT"),
          icon: <SettingOutlined />,
        },
      ];
    case accountStatus.approved:
      return [
        {
          label: "Disburse Deal",
          key: "2",
          route: "/bond-contract-action",
          disabled: !BOM.HasPermission("DISBURSE_BONDCONTRACT"),
          icon: <SettingOutlined />,
        },
        // {
        //   label: "Undo Approval",
        //   key: "3",
        //   // route: "/interbank-contract-action",
        //   // disabled: !BOM.HasPermission("UPDATE_BONDCONTRACT"),
        //   disabled: true,
        //   icon: <SettingOutlined />,
        // },
      ];
    case accountStatus.active:
      return [
        {
          label: "Amend Deal",
          key: "3",
          route: "/bond-contract-action",
          disabled: !BOM.HasPermission("UPDATE_BONDCONTRACT"),
          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Puttable Deal",
          key: "4",
          route: "/bond-contract-action",
          disabled:
            !BOM.HasPermission("PREMATURELYREDEEMPUTTABLE_BONDCONTRACT") ||
            prodDetail?.puttable === false,

          icon: <SettingOutlined />,
        },
        {
          label: "Terminate Callable Deal",
          key: "5",
          route: "/bond-contract-action",
          disabled:
            !BOM.HasPermission("PREMATURELYREDEEM_BONDCONTRACT") ||
            prodDetail?.callable === false,

          icon: <SettingOutlined />,
        },
        {
          label: "Rollover Deal",
          key: "6",
          disabled: true,

          icon: <SettingOutlined />,
        },

        {
          label: "Redeem Deal",
          key: "7",
          disabled: true,
          icon: <SettingOutlined />,
        },
      ];
    default:
      return [];
  }
};

export const handleBondActionButtons = (prodDetail) => {
  const status = prodDetail?.status?.text;
  console.log(status.toLowerCase());

  switch (status.toLowerCase()) {
    case accountStatus.pending:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    case accountStatus.disabled:
      return [
        {
          label: "Approve",
          key: "1",
          disabled: !BOM.HasPermission("APPROVE_SAVINGSACCOUNT"),
          icon: <CheckCircleOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("ACTIVATE_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    case accountStatus.active:
      return [
        {
          label: "Disable",
          key: "1",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <DislikeOutlined />,
        },
        {
          label: "Close",
          key: "2",
          disabled: !BOM.HasPermission("REJECT_SAVINGSACCOUNT"),
          icon: <CloseCircleOutlined />,
        },
      ];
    //   case accountStatus.closed:
    //     return [];
    default:
      return [];
  }
};

export const accountStatus = {
  pending: "pending",
  approved: "approved",
  disabled: "disabled",
  active: "active",
  block: "block",
  withdrawnByApplicant: "withdrawn by applicant",
  rejected: "rejected",
  closed: "closed",
  prematureClosed: "Premature Closed",
  matured: "matured",
};

export const AmountFormat = ({ amount, labelName, currency, precision }) => {
  return (
    <Statistic
      title={`${labelName ? labelName : "-"} ( ${currency ? currency : "-"} )`}
      prefix={currency}
      value={amount ? amount : 0}
      precision={precision ? precision : 2}
    />
  );
};

export const isDebit = (transactionType) => {
  return (
    transactionType.withdrawal === true ||
    transactionType.feeDeduction === true ||
    transactionType.overdraftInterest === true ||
    transactionType.withholdTax === true
  );
};

export const getCurrencySymbol = (currencyCode, currencies = []) => {
  const fallbackSymbols = {
    NGN: "₦",
    CNY: "¥",
  };

  const found = currencies.find((item) => item.value === currencyCode);
  return found?.symbol || fallbackSymbols[currencyCode] || "";
};
